import ConstrainBase from "../ConstrainBase";
import ValidationResult from "../ValidationResult";

/**
 * class IntegerConstrain
 * Validiert ganzzahlige Werte analog zur serverseitigen IntegerConstrain.php
 */
class IntegerConstrain extends ConstrainBase {

  validate(value) {
    if (value === null || value === undefined || value === '') {
      return new ValidationResult(true, '');
    }
    const num = Number(value);
    if (!Number.isInteger(num) || isNaN(num)) {
      return new ValidationResult(false, 'Bitte eine ganze Zahl eingeben.');
    }
    return new ValidationResult(true, '');
  }
}

export default IntegerConstrain;
